module.exports = __webpack_public_path__ + "img/logo-paypal.90bb71c3.png";